import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';
import BackButton from 'src/components/BackButton';
import { StyledTitle } from 'src/Ghg/components/Table/index.styles';
import { StyledFlex } from 'src/components/StyledFlex';
import Form from './Form';

export default function EmployeeSurveyResponseDetail() {
  const { t } = useTranslation('ghg', {
    keyPrefix: 'employeeSurveys.detail',
  });
  const { responseId: _responseId } = useParams<{ responseId: string }>();
  const responseId = _responseId ? parseInt(_responseId, 10) : undefined;

  if (!responseId) return <Navigate to="/ghg/employee-surveys" />;

  return (
    <Box>
      <StyledFlex sx={{ justifyContent: 'flex-start' }}>
        <BackButton fontSize="large" />
        <StyledTitle>{t('title')}</StyledTitle>
        <div />
      </StyledFlex>

      <Form responseId={responseId} />
    </Box>
  );
}
